import React, { useEffect, useState } from "react";
import moment from "moment";
import config from "appConfig";
import { DatePicker } from "antd";
import {
  parseFormControlValue,
  checkEmptyObject
} from "../../../services/utils";
import { InputType, LocalStorageKey } from "../../../models";
import { localStorage } from "../../../services";

const DateSelector = props => {
  const {
    placeholder = "",
    title = "",
    isRequired = false,
    onChange = () => null,
    isDisabled = false,
    max = undefined,
    min = undefined,
    middleValue = false,
    field,
    controlType,
    value,
    customDisabledDates = true
  } = props;



  const handleChange = date => {
    if (date) {
      const value = moment.utc({ year: date.year() });

      switch (controlType) {
        case InputType.month:
          // set the date at middle of month
          value.month(date.month());

          if (middleValue) {
            value.date(15);
          }
          break;

        case InputType.date:
          // set the time at middle of date
          value.month(date.month());
          value.date(date.date());

          if (middleValue) {
            value.hour(12);
          }
          break;

        default:
          throw new Error("Unsupported control type");
      }
      // @ts-ignore
      onChange(parseFormControlValue([field], [value.toISOString()]));
    } else {
      // @ts-ignore
      onChange(undefined);
    }
  };

  const disabledDate = current => {
    // Can not select days before today and today
    return customDisabledDates
      ? (current && current < moment().startOf("month")) ||
          current >
            moment()
              .add(12, "months")
              .endOf("month")
      : current && current > moment().startOf("day");
  };

  let Control;
  let format;

  if (controlType === InputType.month) {
    Control = DatePicker.MonthPicker;
    format = config.monthFormat;
  } else {
    Control = DatePicker;
    format = config.dateFormat;
  }

  return (
    <React.Fragment>
      <span className={`control-title ${isRequired ? "required" : ""}`}>
        {title}
      </span>
      <Control
        disabled={isDisabled}
        format={format}
        placeholder={placeholder}
        onChange={handleChange}
        value={checkEmptyObject(value) ? moment(value[field]) : undefined}
        disabledDate={disabledDate}
        defaultPickerValue={moment()}
      />
    </React.Fragment>
  );
};

export default DateSelector;



// WEBPACK FOOTER //
// ./src/components/FormControls/DateSelector/DateSelector.tsx